import React, { useEffect } from 'react';

const BondPage = () => {

  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css";
    link.rel = "stylesheet";
    link.id = "tailwind-mutualfund"; // Add ID so you can remove it later if needed
    document.head.appendChild(link);

    return () => {
      // Optional: Clean up when component unmounts
      document.getElementById("tailwind-mutualfund")?.remove();
    };
  }, []);
  return (
    <>
      {/* <!-- Hero Section --> */}
      <section className="bg-blue-50 py-16 text-center">
        <h1 className="text-4xl font-bold text-blue-900 mb-4">Invest in Government & Corporate Bonds with Confidence</h1>
        <p className="text-lg text-gray-700 mb-6">GPS Finvest offers seamless, paperless access to top-rated bonds with attractive interest rates.</p>
        {/* <a href="#" className="px-6 py-3 bg-gradient-to-r from-teal-400 to-green-400 text-white rounded-full font-semibold shadow hover:shadow-lg">Explore Bonds</a> */}
        <div ><a className="btn btn-primary" href="https://gpsfinvest.investwell.app/app/#/login">Explore Bonds</a></div>
      </section>

      {/* <!-- What Are Bonds --> */}
      <section className="py-16 bg-white">
        <div className='col-md-12' style={{ display: 'flex', justifyContent: 'center' }}>
          <img src='/images/bonds.png' style={{ height: '300px' }} />
        </div>
        <div className="max-w-4xl mx-auto px-4 text-center mt-3">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">What Are Bonds?</h2>
          <p className="text-lg text-gray-600">Bonds are fixed-income securities issued by governments or companies to raise capital. When you invest in bonds, you lend money to the issuer in exchange for regular interest payments and repayment of the face value on maturity. Bonds are ideal for those looking for stable returns with lower risk.</p>
        </div>
      </section>

      {/* <!-- Why Buy Bonds Through GPS Finvest --> */}
      <section className="py-16 bg-green-50">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-10 text-gray-800">Why Buy Bonds Through GPS Finvest?</h2>
          <div className="grid md:grid-cols-4 gap-6 text-left">
            <div className="hover-card bg-white p-6 rounded-lg shadow">
              <img src="/images/Handpicked_Bonds.png" alt="Large Cap" className="w-16 h-16 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-green-700 mb-2">Handpicked Bonds</h3>
              <p>Choose from top-rated corporate and government bonds.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded-lg shadow">
              <img src="/images/Seamless_Purchase.webp" alt="Large Cap" className="w-16 h-16 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-green-700 mb-2">Seamless Purchase</h3>
              <p>Completely online process with no paperwork or delays.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded-lg shadow">
              <img src="/images/Fixed_Returns.png" alt="Large Cap" className="w-16 h-16 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-green-700 mb-2">Fixed Returns</h3>
              <p>Enjoy predictable interest income at competitive rates.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded-lg shadow">
              <img src="/images/Zero_Commission.jpg" alt="Large Cap" className="w-16 h-16 mx-auto mb-4" />
              <h3 className="text-lg font-semibold text-green-700 mb-2">Zero Commission</h3>
              <p>No hidden charges or middlemen — full transparency.</p>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- How to Buy Bonds --> */}
      <section className="py-16 bg-white">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-10 text-gray-800">How to Buy Bonds via GPS Finvest</h2>
          <div className="grid md:grid-cols-4 gap-6 text-left">
            <div className="hover-card bg-blue-50 p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-blue-800 mb-2">1. Sign Up</h3>
              <p>Create your account using PAN and mobile number.</p>
            </div>
            <div className="hover-card bg-blue-50 p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-blue-800 mb-2">2. Complete KYC</h3>
              <p>Finish Aadhaar-based KYC in under 5 minutes.</p>
            </div>
            <div className="hover-card bg-blue-50 p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-blue-800 mb-2">3. Browse Bonds</h3>
              <p>View live bond listings with ratings and maturity terms.</p>
            </div>
            <div className="hover-card bg-blue-50 p-6 rounded-lg shadow">
              <h3 className="text-lg font-semibold text-blue-800 mb-2">4. Invest & Track</h3>
              <p>Buy online and track interest payments in your dashboard.</p>
            </div>
          </div>
        </div>
      </section>

      {/* <!-- Bond Investment Benefits --> */}
      <section className="py-16 bg-green-50">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Benefits of Investing in Bonds</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 text-left">
            <div className="hover-card bg-white p-6 rounded shadow">
              <h3 className="text-lg font-semibold text-green-700 mb-2">Capital Preservation</h3>
              <p>Ideal for risk-averse investors who want steady growth.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded shadow">
              <h3 className="text-lg font-semibold text-green-700 mb-2">Fixed Income</h3>
              <p>Earn regular interest payouts on a fixed schedule.</p>
            </div>
            <div className="hover-card bg-white p-6 rounded shadow">
              <h3 className="text-lg font-semibold text-green-700 mb-2">Diversification</h3>
              <p>Add stability to your portfolio beyond equities or mutual funds.</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BondPage;
